import * as React from "react"
import { BasicTableSeeker } from "@ui-seeker/core"

import { BORDER_COLOR, BORDER_STYLE } from "@constants"
import { favFiltersData } from "../@signals"
import { nameColumn, actionsColumn } from "./columns"

export default function GroupsTable ({ dashboardKey, ...props }) {

    return <BasicTableSeeker
        data={favFiltersData.value}
        headers={[[
            { 
                label: 'Group Name', 
                sx: { borderLeft: BORDER_STYLE, borderColor: BORDER_COLOR, fontWeight: 'bold', backgroundColor: "primary.lighter" } 
            },
            { 
                label: 'Actions',
                sx: { width: 150, borderLeft: BORDER_STYLE, borderColor: BORDER_COLOR, fontWeight: 'bold', backgroundColor: "primary.lighter" } 
            }
        ]]}
        columns={[
            nameColumn(),
            actionsColumn(dashboardKey)
        ]}
        cardProps={{ sx: { boxShadow: 0 } }}
        sx={{ overflowX: 'hidden', width: 700 }}
        {...props}
    />
}